import Analytics from 'src/lib/analytics';
export const pageAnalytics = Analytics.event.builder().setPage('EP_Question');
